import { collectionsDuck } from '@eb/redux-destination';

import {
    GA_HOME_CATEGORY,
    GA_HOME_FEED_CATEGORY,
    GA_POOR_CONTENT_ACTION,
    GA_SMALL_CITY_FALLBACK_ACTION,
    GA_HOME_BANNER_CTA_CLICK,
    GA_CLICK_VIEW_ONLINE_COLLECTION_ACTION,
    GA_TRANSITION_ONLINE_COLLECTION,
} from '../../../../constants/analytics';
import { TABS_CONFIG } from '../../../../constants/tabConfig';

import {
    isSmallCityFallback,
    isZeroContent,
    storeHomeFeedState,
} from '../../utils';

const {
    actions: { getCollectionsForPlace },
} = collectionsDuck;

const trackContentQuality = ({ action, label, loggedIn = true }) => ({
    type: 'POOR_CONTENT',
    meta: {
        analytics: {
            category: loggedIn ? GA_HOME_FEED_CATEGORY : GA_HOME_CATEGORY,
            action,
            label,
            nonInteraction: true,
        },
    },
});

export const verifyPoorContent = ({ buckets, events, actionName }) => (
    dispatch,
    getState,
) => {
    const {
        location: { currentPlace },
        user: { isAuthenticated },
    } = getState();
    const actionLabel = actionName ? `- ${actionName}` : '';

    if (isSmallCityFallback({ buckets, events })) {
        dispatch(
            trackContentQuality({
                loggedIn: isAuthenticated,
                action: GA_SMALL_CITY_FALLBACK_ACTION + actionLabel,
                label: currentPlace,
            }),
        );
    }

    if (isZeroContent({ buckets, events })) {
        dispatch(
            trackContentQuality({
                loggedIn: isAuthenticated,
                action: GA_POOR_CONTENT_ACTION + actionLabel,
                label: currentPlace,
            }),
        );
    }
};

export const UPDATE_TAB_KEY = 'UPDATE_TAB_KEY';
export const updateTabKey = (payload) => (dispatch) => {
    storeHomeFeedState({
        tabKey: payload.tabKey,
        tabKeyLabel: payload.tabKeyLabel,
    });
    dispatch({
        type: UPDATE_TAB_KEY,
        payload,
    });
};

export const UPDATE_CONTENT = 'UPDATE_CONTENT';
export const updateContent = ({ entities, entityContext }) => ({
    type: UPDATE_CONTENT,
    payload: {
        entities,
        entityContext,
    },
});

export const CLICK_CTA_SEASONAL = 'CLICK_CTA_SEASONAL';
const trackCTASeasonal = ({ loggedIn = true, customContentCtaLink }) => ({
    type: CLICK_CTA_SEASONAL,
    meta: {
        analytics: {
            category: loggedIn ? GA_HOME_FEED_CATEGORY : GA_HOME_CATEGORY,
            action: GA_HOME_BANNER_CTA_CLICK,
            label: customContentCtaLink,
            onWindowUnload: true,
        },
    },
});

export const clickCTASeasonal = () => (dispatch, getState) => {
    const {
        user: { isAuthenticated },
        header: { customContentCtaPrefix, customContentCtaLink } = {},
    } = getState();

    return dispatch(
        trackCTASeasonal({
            categoryPrefixed: customContentCtaPrefix,
            loggedIn: isAuthenticated,
            customContentCtaLink,
        }),
    );
};
export const SET_EDITORIAL_COLLECTIONS =
    'collections/set-editorial-collections';
export const fetchCollectionsForPlace = (tabKey) => (dispatch, getState) => {
    const {
        location: { placeId },
        app: { tld, locale },
    } = getState();

    const { collections } = TABS_CONFIG[tabKey];

    if (!collections || !collections[tld] || !collections[tld][locale]) {
        return;
    }

    const collectionsByTLD = collections[tld][locale];

    dispatch(
        getCollectionsForPlace({
            placeId,
            collectionsToShow: collectionsByTLD,
            customActionType: SET_EDITORIAL_COLLECTIONS,
        }),
    );
};

export const CLICK_ONLINE_COLLECTION = 'CLICK_ONLINE_COLLECTION';
const trackOnClickOnlineCollection = ({
    loggedIn = true,
    collectionId = '',
}) => ({
    type: CLICK_ONLINE_COLLECTION,
    meta: {
        analytics: {
            category: loggedIn ? GA_HOME_FEED_CATEGORY : GA_HOME_CATEGORY,
            action: GA_CLICK_VIEW_ONLINE_COLLECTION_ACTION,
            label: collectionId,
            onWindowUnload: true,
        },
    },
});
export const clickOnOnlineCollection = ({ label }) => (dispatch, getState) => {
    const {
        user: { isAuthenticated },
    } = getState();

    return dispatch(
        trackOnClickOnlineCollection({
            loggedIn: isAuthenticated,
            collectionId: label,
        }),
    );
};

export const CLICK_COLLECTION_TRANSITION = 'CLICK_COLLECTION_TRANSITION';
const trackOnTransitionOnlineCollection = ({
    loggedIn = true,
    collectionId = '',
    index = 0,
}) => ({
    type: CLICK_COLLECTION_TRANSITION,
    meta: {
        analytics: {
            category: loggedIn ? GA_HOME_FEED_CATEGORY : GA_HOME_CATEGORY,
            action: GA_TRANSITION_ONLINE_COLLECTION,
            label: collectionId,
            value: index,
        },
    },
});
export const clickOnTransitionOnlineCollection = ({ label, value }) => (
    dispatch,
    getState,
) => {
    const {
        user: { isAuthenticated },
    } = getState();

    return dispatch(
        trackOnTransitionOnlineCollection({
            loggedIn: isAuthenticated,
            collectionId: label,
            index: value,
        }),
    );
};
